import { render, staticRenderFns } from "./CrearTipoDispositivoModal.vue?vue&type=template&id=9f28a22e&"
import script from "./CrearTipoDispositivoModal.vue?vue&type=script&lang=ts&"
export * from "./CrearTipoDispositivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9f28a22e', component.options)
    } else {
      api.reload('9f28a22e', component.options)
    }
    module.hot.accept("./CrearTipoDispositivoModal.vue?vue&type=template&id=9f28a22e&", function () {
      api.rerender('9f28a22e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoDispositivo/CrearTipoDispositivoModal.vue"
export default component.exports